import { useState, useEffect, useCallback } from 'react'

type NotificationStatus = NotificationPermission | 'not-available'

export const useNotification = () => {
  const [status, setStatus] = useState<NotificationStatus>('not-available')
  useEffect(() => {
    if ('Notification' in window) {
      setStatus(Notification.permission)
    } else {
      setStatus('not-available')
    }
  }, [])

  const requestPermission = useCallback(async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission()
      setStatus(permission)
      return permission
    }
    return 'not-available' as const
  }, [])

  return { status, requestPermission }
}
